import { X } from 'lucide-react';
import historySvg from './icons/history.svg';

export default function AgentPanelActions({
  onHistory,
  onClose,
}: {
  onHistory: () => void;
  onClose: () => void;
}) {
  return (
    <div className="flex items-center gap-l">
      <button
        type="button"
        className="btn-reset block size-6"
        aria-label="History"
        onClick={onHistory}
      >
        <span
          className="block size-full"
          style={{
            backgroundColor: 'var(--gray-text)',
            mask: `url(${JSON.stringify(historySvg)}) no-repeat center / contain`,
            WebkitMask: `url(${JSON.stringify(historySvg)}) no-repeat center / contain`,
          }}
        />
      </button>
      <button
        type="button"
        className="btn-reset grid size-8 place-items-center rounded-xs bg-background-main text-gray-text"
        aria-label="Close"
        onClick={onClose}
      >
        <X size={20} />
      </button>
    </div>
  );
}
